module.exports = __webpack_public_path__ + "img/Katarina_home_02.07c46918.jpg";